import { useRef, useState } from "react";
import { Swiper, SwiperSlide, SwiperRef } from "swiper/react";
import { Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { getStrapiMedia } from "../../utils/utils";
import "./HomepageSlider.scss";
import { SliderComponent_Plain } from "../../types/components/shared/SliderComponent.ts";
import type { Swiper as SwiperInstance } from "swiper";
import { CategoryComponent_Plain } from "../../types/components/products/CategoryComponent.ts";
import VideoSliderItem from "../VideoSliderItem/VideoSliderItem";
const HomepageSlider = ({
  data,
  products,
}: {
  data: SliderComponent_Plain[];
  products: CategoryComponent_Plain[];
}) => {
  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const tabs = products.map((category, i: number) => (
    <a
      className="main-slider__tags-item"
      key={i}
      href={`#${category.id}`}
      onClick={(e) => {
        e.preventDefault();
        const productsSection = document.querySelector(".box-products");
        if (productsSection) {
          productsSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        const tabElement = document.querySelector(
          `.tabs-nav__item[data-index="${i}"]`,
        );
        if (tabElement) {
          (tabElement as HTMLElement).click();
        }
      }}
      data-index={i}
    >
      {category.title}
    </a>
  ));
  console.log(tabs);
  const slides = data.map((item: SliderComponent_Plain, i: number) => (
    <SwiperSlide key={i} className="slider__item" data-dark={item.dark ? 1 : 0}>
      {item.image ? (
        item.image.mime == "video/mp4" || item.image.mime == "video/webm" ? (
          <VideoSliderItem
            videoUrl={item.image.url}
            mimeType={item.image.mime}
            isActive={activeIndex === i}
            isPreloaded={Math.abs(activeIndex - i) <= 1} // Preload сусідні слайди
            priority={i === 0} // Перший слайд має пріоритет
          />
        ) : (
          <img src={getStrapiMedia(item.image.url)} alt={item.title} />
        )
      ) : (
        ""
      )}
      <div className="slider__text">
        {i === 0 ? (
          <h1 className="slider__title">
            <div className="wrapper">{item.title}</div>
          </h1>
        ) : (
          <div className="slider__title">
            <div className="wrapper">{item.title}</div>
          </div>
        )}
        <div className="slider__subtitle">
          <div className="slider__subtitle-text">{item.description}</div>
        </div>
      </div>
    </SwiperSlide>
  ));
  const updateHeaderClass = (swiper: SwiperInstance) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const isDark = activeSlide?.getAttribute("data-dark") === "1";
    const header = document.querySelector("header");
    if (header) {
      if (isDark) {
        header.classList.add("dark-slide");
      } else {
        header.classList.remove("dark-slide");
      }
    } else {
      console.warn("Header element not found");
    }
  };

  const sanitizeDuplicateH1 = (swiper: SwiperInstance) => {
    swiper.slides.forEach((slideEl) => {
      if (!(slideEl instanceof Element)) return;
      if (!slideEl.classList.contains("swiper-slide-duplicate")) return;

      const duplicateHeading = slideEl.querySelector("h1.slider__title");
      if (!duplicateHeading) return;

      const replacement = document.createElement("div");
      replacement.className = duplicateHeading.className;
      replacement.innerHTML = duplicateHeading.innerHTML;
      duplicateHeading.replaceWith(replacement);
    });
  };

  return (
    <section className="main-slider main-slider__international">
      {/* <div className="main-slider__tags">{tabs}</div> */}
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, EffectFade, Navigation]}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        effect="fade"
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        navigation
        onSwiper={(swiper) => {
          console.log("Swiper initialized", swiper);
          setActiveIndex(swiper.realIndex || 0);
          updateHeaderClass(swiper);
          sanitizeDuplicateH1(swiper);
        }}
        onSlideChange={(swiper) => {
          console.log("Slide changed", swiper.activeIndex);
          setActiveIndex(swiper.realIndex || swiper.activeIndex);
          updateHeaderClass(swiper);
          sanitizeDuplicateH1(swiper);
        }}
        className="slider"
      >
        {slides}
      </Swiper>
    </section>
  );
};
export default HomepageSlider;
